import React from "react";
import { DataGrid, GridToolbarQuickFilter } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import CheckIcon from "@mui/icons-material/Check";

function QuickSearchToolbar() {
    return (
        <Box sx={{ p: 0.5, pb: 0 }}>
            <GridToolbarQuickFilter />
        </Box>
    );
}

export default function Basic(props) {
    let rows = [];

    if (props.servicePlanData !== undefined) {
        rows = Object.keys(props.servicePlanData).map((key, index) => ({
            id: index,
            planKey: key,
            servicePlanID: props.servicePlanData[key]["ServicePlanID"],
            servicePlanName: props.servicePlanData[key]["ServicePlanName"],
            servicePlanDescription: props.servicePlanData[key]["ServicePlanDescription"],
            downloadkbps: props.servicePlanData[key]["DownloadKbps"],
            uploadkbps: props.servicePlanData[key]["UploadKbps"],
            defaultPlanWired:
                props.defaultVenueConfig?.["DefaultServicePlanID_GlobalWirelessPlusLocalWiredAccess"] ===
                props.servicePlanData[key]["ServicePlanID"],
            defaultPlanWireless:
                props.defaultVenueConfig?.["DefaultServicePlanID_LocalWirelessAccess"] ===
                props.servicePlanData[key]["ServicePlanID"],
            defaultPlanRoaming:
                props.defaultVenueConfig?.["DefaultServicePlanID_Roaming"] ===
                props.servicePlanData[key]["ServicePlanID"],
            smscode: props.servicePlanData[key]["SMSCode"],
            billingCycleHours: props.servicePlanData[key]["BillingCycleHours"],
            billingCyclePrice:
                props.currencySymbol +
                props.servicePlanData[key]["BillingCyclePrice." + props.currencyName] / 100,
            trialCycles: props.servicePlanData[key]["TrialCycles"],
            wirelessOnlyPlan: props.servicePlanData[key]["WirelessOnlyPlan"] || false,
        }));
    }

    const columns = [
        { headerName: "Name", field: "servicePlanName", minWidth: 180 },
        { headerName: "Description", field: "servicePlanDescription", minWidth: 200 },
        { headerName: "Download (kbps)", field: "downloadkbps", minWidth: 145 },
        { headerName: "Upload (kbps)", field: "uploadkbps", minWidth: 130 },
        {
            headerName: "Default Residential",
            field: "defaultPlanWired",
            minWidth: 160,
            renderCell: (params) => (params.value ? <CheckIcon fontSize="small" /> : null),
        },
        {
            headerName: "Default Guest",
            field: "defaultPlanWireless",
            minWidth: 135,
            renderCell: (params) => (params.value ? <CheckIcon fontSize="small" /> : null),
        },
        {
            headerName: "Default Roaming",
            field: "defaultPlanRoaming",
            minWidth: 148,
            renderCell: (params) => (params.value ? <CheckIcon fontSize="small" /> : null),
        },
        {
            headerName: "Wireless Only",
            field: "wirelessOnlyPlan",
            minWidth: 120,
            renderCell: (params) => (params.value ? <CheckIcon fontSize="small" /> : null),
        },
        { headerName: "SMS Code", field: "smscode", minWidth: 120 },
        { headerName: "Billing Cycle Hours", field: "billingCycleHours", minWidth: 165 },
        { headerName: "Billing Cycle Price", field: "billingCyclePrice", minWidth: 158 },
        { headerName: "Trial Cycles", field: "trialCycles", minWidth: 100 },
    ];

    return (
        <div style={{ height: 400, width: "100%" }}>
            <DataGrid
                rows={rows}
                columns={columns}
                hideFooterPagination={false}
                hideFooter={false}
                getRowHeight={({ id, densityFactor }) => 50 * densityFactor}
                slots={{ toolbar: QuickSearchToolbar }}
                onRowClick={(params) =>
                    props.modifyServicePlan(params.row.planKey, params.row.servicePlanID)
                }
                sx={{ cursor: "pointer" }}
            />
        </div>
    );
}
